<script lang="ts">
  import { app } from "../lib/store.svelte.ts";
  import { TOAST_DISMISS_LABEL, TOAST_DISMISS_SYMBOL } from "../settings/shared.ts";
</script>

<div class="toasts" role="status" aria-live="polite">
  {#each app.toasts as t (t.id)}
    <div class="toast" class:error={t.kind === "error"}>
      <span>{t.text}</span>
      {#if t.action}
        <button class="act" onclick={() => { t.action?.run(); app.dismiss(t.id); }}>{t.action.label}</button>
      {/if}
      <button class="x" aria-label={TOAST_DISMISS_LABEL} onclick={() => app.dismiss(t.id)}>{TOAST_DISMISS_SYMBOL}</button>
    </div>
  {/each}
</div>

<style>
  .toasts {
    position: fixed;
    left: 50%;
    bottom: calc(env(safe-area-inset-bottom) + 84px);
    transform: translateX(-50%);
    z-index: 100;
    display: grid;
    gap: 8px;
    width: min(440px, calc(100vw - 32px));
  }

  .toast {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 10px 10px 14px;
    border-radius: var(--r-md);
    background: var(--ink);
    color: var(--paper);
    font-size: var(--t-sm);
    box-shadow: var(--shadow-pop);
  }

  .toast.error {
    background: var(--owes);
    color: #fff;
  }

  .toast span {
    flex: 1;
  }

  .act {
    border: 0;
    background: none;
    color: inherit;
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
  }

  .x {
    border: 0;
    background: none;
    color: inherit;
    opacity: 0.7;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    padding: 2px 6px;
  }

  @media (min-width: 861px) {
    .toasts {
      bottom: 24px;
    }
  }
</style>
